module.exports = __webpack_public_path__ + "static/media/social-github.d2bf2e36.svg";